import { api } from "utils";
import { PUBLIC_V1 } from "constant/URL";
import { objectToQueryParams } from "utils/objectToQueryParams";

export const getListBuyerMatch = async (params) => {
  const newParams =
    !!params && typeof params === "object"
      ? `?${objectToQueryParams(params)}`
      : "";
  return api({}, true).get(`/${PUBLIC_V1}/buyer_match${newParams}`);
};

export const getListCustomer = async (params) => {
  const newParams =
    !!params && typeof params === "object"
      ? `?${objectToQueryParams(params)}`
      : "";
  return api({}, true).get(
    `/${PUBLIC_V1}/buyer_match/list_customer${newParams}`
  );
};

export const getCountBuyerMatch = async (params) => {
  const newParams =
    !!params && typeof params === "object"
      ? `?${objectToQueryParams(params)}`
      : "";
  return api({}, true).get(
    `/${PUBLIC_V1}/buyer_match/count_buyer_match${newParams}`
  );
};

export const getListListingCustomer = async (id, params) => {
  const newParams =
    !!params && typeof params === "object"
      ? `?${objectToQueryParams(params)}`
      : "";
  return api({}, true).get(
    `/${PUBLIC_V1}/buyer_match/${id}/list_listing_customer${newParams}`
  );
};

export const getDetailCustomer = async (id) => {
  return api({}, true).get(`/${PUBLIC_V1}/buyer_match/${id}`);
};

export const updateCustomer = async (id, data) => {
  return api({}, true).patch(
    `/${PUBLIC_V1}/buyer_match/${id}/update_customer`,
    data
  );
};

export const updateStatusCustomer = async (id, data) => {
  return api({}, true).patch(
    `/${PUBLIC_V1}/buyer_match/${id}/update_status_customer`,
    data
  );
};

export const deleteCustomer = async (id) => {
  return api({}, true).delete(`/${PUBLIC_V1}/buyer_match/${id}`);
};

export const createCustomer = async (data) => {
  return api({}, true).post(`/${PUBLIC_V1}/buyer_match/create_customer`, data);
};

export const updateStatusListing = async (id, data) => {
  return api({}, true).put(
    `/${PUBLIC_V1}/listing_buyer_match/${id}/update_status_listing_customer`,
    data
  );
};

export const getCountListingBuyerMatch = async (id) => {
  return api({}, true).get(
    `/${PUBLIC_V1}/buyer_match/${id}/count_listing_buyer_match`
  );
};

export const getDetailListingBuyerMatch = async (id) => {
  return api({}, true).get(`/${PUBLIC_V1}/listing_buyer_match/${id}`)
};
